import { Text, View } from '@react-pdf/renderer';

import { usePDFContext } from '../../../PDFProvider';
import { styles } from '../styles';

type QuoteDetailsProps = {
  children: React.ReactNode;
};

export function QuoteDetails({ children }: QuoteDetailsProps) {
  const { customer } = usePDFContext();

  return (
    <>
      <View
        style={[styles.row, { margin: 10, paddingLeft: 10, paddingRight: 10 }]}
      >
        <Text>Attn: {customer.attentionName}</Text>
      </View>

      <View style={styles.row}>{children}</View>
    </>
  );
}
